/**
 * Genres Section for Assistant Profile
 * Allows selection of genres with experience levels
 */
import { Card } from "@/components/ui/card";
import { GENRES, GENRE_LEVELS } from "@/lib/profileOptions";

export default function GenresSection({ genres, setGenres }) {
  const setGenreLevel = (genreValue, level) => {
    const existing = genres.find(g => g.genre === genreValue);
    if (existing) {
      if (level === null) {
        // Remove genre
        setGenres(genres.filter(g => g.genre !== genreValue));
      } else {
        // Update level
        setGenres(genres.map(g => 
          g.genre === genreValue ? { genre: genreValue, level } : g
        ));
      }
    } else if (level !== null) {
      // Add new genre
      setGenres([...genres, { genre: genreValue, level }]);
    }
  };

  const getGenreLevel = (genreValue) => {
    const existing = genres.find(g => g.genre === genreValue);
    return existing ? existing.level : null;
  };

  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-2">Genres & Specialties</h2>
      <p className="text-white/50 mb-6">Select your experience level for each genre</p>
      
      <div className="space-y-3">
        {GENRES.map((genre) => {
          const currentLevel = getGenreLevel(genre.value);
          return (
            <div 
              key={genre.value} 
              className="flex items-center justify-between p-3 bg-white/[0.05] border border-white/10 rounded-sm"
            >
              <span className="font-medium">{genre.label}</span>
              <div className="flex gap-2">
                {GENRE_LEVELS.map((level) => {
                  const isSelected = currentLevel === level.value;
                  return (
                    <button
                      key={level.value}
                      type="button"
                      onClick={() => setGenreLevel(genre.value, isSelected ? null : level.value)}
                      className={`px-3 py-1 text-sm rounded-sm transition-all ${
                        isSelected 
                          ? "bg-white text-black" 
                          : "bg-white/10 text-white/60 hover:bg-white/20"
                      }`}
                      data-testid={`genre-${genre.value}-${level.value}`}
                    >
                      {level.label}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
